/**
 * Payment Routes
 * ============================================================================
 *
 * Purpose:
 * --------
 * Defines payment-related routes.
 * ============================================================================
 */

import { LAYOUT_TYPES, ROUTE_PATHS, USER_ROLES } from 'navigation/constants';

import type { RouteGroup } from 'navigation/types';
import { lazy } from 'react';

const PaymentsPage = lazy(() => import('@/features/payments/ui/pages/payments-page'));
const PaymentDetailPage = lazy(() => import('@/features/payments/ui/pages/payment-detail-page'));
const AddPaymentPage = lazy(() => import('@/features/payments/ui/pages/add-payment-page'));

export const paymentRoutes: RouteGroup = {
  name: 'payments',
  layout: LAYOUT_TYPES.DASHBOARD,
  permission: {
    requiresAuth: true,
  },
  routes: [
    {
      path: ROUTE_PATHS.PAYMENTS,
      component: PaymentsPage,
      meta: {
        title: 'payments:page.title',
        icon: 'CreditCardIcon',
        showInNav: true,
        navOrder: 7,
      },
    },
    {
      path: ROUTE_PATHS.PAYMENT_CREATE,
      component: AddPaymentPage,
      permission: {
        allowedRoles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.MANAGER],
      },
      meta: {
        title: 'payments:addPayment.title',
        parent: ROUTE_PATHS.PAYMENTS,
      },
    },
    {
      path: ROUTE_PATHS.PAYMENT_DETAIL,
      component: PaymentDetailPage,
      meta: {
        title: 'payments:detail.title',
        parent: ROUTE_PATHS.PAYMENTS,
      },
    },
  ],
};
